import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import 'core-js/modules/es6.array.map';
import 'core-js/modules/es6.promise';
import 'core-js/modules/es6.string.iterator';
import 'core-js/modules/web.dom.iterable';
import 'core-js/modules/es6.array.iterator';
import 'core-js/modules/es6.object.keys';
import _objectSpread from '@babel/runtime/helpers/objectSpread';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import 'regenerator-runtime/runtime';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import Vue from 'vue';
import { toPairs, fromPairs } from 'ramda';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'core-js/modules/es6.array.for-each';
import 'core-js/modules/es6.array.filter';
import 'core-js/modules/es6.function.name';

var QueryRenderer = Vue.component('QueryRenderer', {
  props: {
    query: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    queries: {
      type: Object
    },
    cubejsApi: {
      type: Object,
      required: true
    },
    builderProps: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      mutexObj: {},
      error: undefined,
      resultSet: undefined,
      loading: true,
      sqlQuery: undefined
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var query, queries;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              query = this.query, queries = this.queries;

              if (!query) {
                _context.next = 4;
                break;
              }

              _context.next = 4;
              return this.load(query);

            case 4:
              if (!queries) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return this.loadQueries(queries);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function mounted() {
      return _mounted.apply(this, arguments);
    };
  }(),
  render: function render(createElement) {
    var resultSet = this.resultSet,
        error = this.error,
        loading = this.loading,
        sqlQuery = this.sqlQuery;

    if (!loading && resultSet) {
      var slotProps = _objectSpread({
        resultSet: this.queries ? resultSet || {} : resultSet,
        error: error,
        isLoading: loading,
        sqlQuery: sqlQuery
      }, this.builderProps);

      return createElement('div', this.$scopedSlots.default(slotProps));
    } else {
      return createElement('div', this.$scopedSlots.default(_objectSpread({
        loading: loading,
        error: error,
        sqlQuery: sqlQuery
      }, this.builderProps)));
    }
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(query) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.loading = true;

                if (!(query && Object.keys(query).length)) {
                  _context2.next = 21;
                  break;
                }

                if (!(this.loadSql === 'only')) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 6;
                return this.cubejsApi.sql(query, {
                  mutexObj: this.mutexObj,
                  mutexKey: 'sql'
                });

              case 6:
                this.sqlQuery = _context2.sent;
                _context2.next = 21;
                break;

              case 9:
                if (!this.loadSql) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 12;
                return this.cubejsApi.sql(query, {
                  mutexObj: this.mutexObj,
                  mutexKey: 'sql'
                });

              case 12:
                this.sqlQuery = _context2.sent;
                _context2.next = 15;
                return this.cubejsApi.load(query, {
                  mutexObj: this.mutexObj,
                  mutexKey: 'query'
                });

              case 15:
                this.resultSet = _context2.sent;
                _context2.next = 21;
                break;

              case 18:
                _context2.next = 20;
                return this.cubejsApi.load(query, {
                  mutexObj: this.mutexObj,
                  mutexKey: 'query'
                });

              case 20:
                this.resultSet = _context2.sent;

              case 21:
                this.loading = false;
                _context2.next = 29;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t0 = _context2["catch"](0);
                this.error = _context2.t0;
                this.resultSet = undefined;
                this.loading = false;

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 24]]);
      }));

      return function load(_x) {
        return _load.apply(this, arguments);
      };
    }(),
    loadQueries: function () {
      var _loadQueries = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(queries) {
        var _this = this;

        var resultPromises;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                this.loading = true;
                resultPromises = Promise.all(toPairs(queries).map(function (_ref) {
                  var _ref2 = _slicedToArray(_ref, 2),
                      name = _ref2[0],
                      query = _ref2[1];

                  return _this.cubejsApi.load(query, {
                    mutexObj: _this.mutexObj,
                    mutexKey: name
                  }).then(function (r) {
                    return [name, r];
                  });
                }));
                _context3.t0 = fromPairs;
                _context3.next = 6;
                return resultPromises;

              case 6:
                _context3.t1 = _context3.sent;
                this.resultSet = (0, _context3.t0)(_context3.t1);
                this.loading = false;
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t2 = _context3["catch"](0);
                this.error = _context3.t2;
                this.loading = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 11]]);
      }));

      return function loadQueries(_x2) {
        return _loadQueries.apply(this, arguments);
      };
    }()
  },
  watch: {
    query: function query(val) {
      if (val) {
        this.load(val);
      }
    },
    queries: function queries(val) {
      if (val) {
        this.loadQueries(val);
      }
    }
  }
});

var QueryBuilder = Vue.component('QueryBuilder', {
  components: {
    QueryRenderer: QueryRenderer
  },
  props: {
    query: {
      type: Object
    },
    cubejsApi: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      meta: undefined,
      updatedQuery: this.query,
      granularities: []
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.cubejsApi.meta();

            case 2:
              this.meta = _context.sent;
              this.granularities = [{
                name: 'hour',
                title: 'Hour'
              }, {
                name: 'day',
                title: 'Day'
              }, {
                name: 'week',
                title: 'Week'
              }, {
                name: 'month',
                title: 'Month'
              }, {
                name: 'year',
                title: 'Year'
              }];

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function mounted() {
      return _mounted.apply(this, arguments);
    };
  }(),
  render: function render(createElement) {
    var _this = this;

    var cubejsApi = this.cubejsApi,
        meta = this.meta;

    if (meta) {
      var toQuery = function toQuery(member) {
        return member.name;
      };

      var queryElements = ['measures', 'dimensions', 'segments', 'timeDimensions', 'filters'];
      var childProps = {
        meta: meta,
        query: this.updatedQuery,
        validatedQuery: this.validatedQuery,
        isQueryPresent: this.isQueryPresent,
        chartType: this.chartType,
        measures: (this.updatedQuery.measures || []).map(function (m, i) {
          return _objectSpread({
            index: i
          }, meta.resolveMember(m, 'measures'));
        }),
        dimensions: (this.updatedQuery.dimensions || []).map(function (m, i) {
          return _objectSpread({
            index: i
          }, meta.resolveMember(m, 'dimensions'));
        }),
        segments: (this.updatedQuery.segments || []).map(function (m, i) {
          return _objectSpread({
            index: i
          }, meta.resolveMember(m, 'segments'));
        }),
        timeDimensions: (this.updatedQuery.timeDimensions || []).map(function (m, i) {
          return _objectSpread({}, m, {
            dimension: _objectSpread({}, meta.resolveMember(m.dimension, 'dimensions'), {
              granularities: _this.granularities
            }),
            index: i
          });
        }),
        filters: (this.updatedQuery.filters || []).map(function (m, i) {
          return _objectSpread({}, m, {
            dimension: meta.resolveMember(m.dimension, ['dimensions', 'measures']),
            operators: meta.filterOperatorsForMember(m.dimension, ['dimensions', 'measures']),
            index: i
          });
        }),
        availableMeasures: meta.membersForQuery(this.updatedQuery, 'measures') || [],
        availableDimensions: meta.membersForQuery(this.updatedQuery, 'dimensions') || [],
        availableTimeDimensions: (meta.membersForQuery(this.updatedQuery, 'dimensions') || []).filter(function (m) {
          return m.type === 'time';
        }),
        availableSegments: meta.membersForQuery(this.updatedQuery, 'segments') || [],
        updateChartType: this.updateChart
      };
      queryElements.forEach(function (e) {
        if (e === 'timeDimensions') {
          toQuery = function toQuery(member) {
            return {
              dimension: member.dimension.name,
              granularity: member.granularity,
              dateRange: member.dateRange
            };
          };
        } else if (e === 'filters') {
          toQuery = function toQuery(member) {
            return {
              dimension: member.dimension.name,
              operator: member.operator,
              values: member.values
            };
          };
        }

        var name = e.charAt(0).toUpperCase() + e.slice(1);

        childProps["add".concat(name)] = function (member) {
          _this.updatedQuery = _objectSpread({}, _this.updatedQuery, _defineProperty({}, e, (_this.updatedQuery[e] || []).concat(toQuery(member))));
        };

        childProps["update".concat(name)] = function (member, updateWith) {
          var members = (_this.updatedQuery[e] || []).concat([]);
          members.splice(member.index, 1, toQuery(updateWith));
          _this.updatedQuery = _objectSpread({}, _this.updatedQuery, _defineProperty({}, e, members));
        };

        childProps["remove".concat(name)] = function (member) {
          var members = (_this.updatedQuery[e] || []).concat([]);
          members.splice(member.index, 1);
          _this.updatedQuery = _objectSpread({}, _this.updatedQuery, _defineProperty({}, e, members));
        };

        childProps["set".concat(name)] = function (members) {
          _this.updatedQuery = _objectSpread({}, _this.updatedQuery, _defineProperty({}, e, members.map(function (e) {
            return e.name;
          }) || []));
        };
      });
      return createElement(QueryRenderer, {
        props: {
          query: this.validatedQuery,
          cubejsApi: cubejsApi,
          builderProps: childProps
        },
        scopedSlots: this.$scopedSlots
      });
    } else {
      return null;
    }
  },
  computed: {
    isQueryPresent: function isQueryPresent() {
      var query = this.updatedQuery;
      return query.measures && query.measures.length > 0 || query.dimensions && query.dimensions.length > 0 || query.timeDimensions && query.timeDimensions.length > 0;
    },
    validatedQuery: function validatedQuery() {
      var updatedQuery = this.updatedQuery;
      return _objectSpread({}, updatedQuery, {
        filters: (updatedQuery.filters || []).filter(function (f) {
          return f.operator;
        })
      });
    }
  },
  methods: {
    updateChart: function updateChart(chartType) {
      this.chartType = chartType;
    }
  }
});

var index = {};

export default index;
export { QueryRenderer, QueryBuilder };
